import { CUSTOM_EVENT_NAME, DrawerEventType, OpenDrawerEventPayload } from '@typesApp/AppEvent'
import { setLocalBasePath } from './navigationUtil'

type EventDetail = {
  type: DrawerEventType
  payload?: OpenDrawerEventPayload
}

type DrawerEventEmitter = {
  openDrawer: (payload?: OpenDrawerEventPayload) => void
}

/**
 * Emit an event to the drawer
 */
const eventEmitter = (): DrawerEventEmitter => {
  const dispatch = (detail: EventDetail) => {
    document.dispatchEvent(
      new CustomEvent(CUSTOM_EVENT_NAME.DRAWER, {
        detail,
      })
    )
  }

  const openDrawer = (payload?: OpenDrawerEventPayload) => {
    setLocalBasePath()
    dispatch({ type: 'onOpenDrawer', payload })
  }

  return {
    openDrawer,
  }
}

export const drawerEventEmitter = eventEmitter()
